// export const API_URL = `http://localhost:8080`;
// export const API_URL = `https://api.neki.app`;
export const API_URL = process.env.NEXT_PUBLIC_API_HOST;
export const API_BASE_URL = `${API_URL}/v1`;

export const PAYPAL_BASE_URL = process.env.REACT_APP_PAYPAL_BASE_URL;
export const PAYPAL_PAYEE_EMAIL = process.env.REACT_APP_PAYPAL_PAYEE_EMAIL;
export const PAYPAL_PROGRAM_ID = process.env.REACT_APP_PAYPAL_PROGRAM_ID;

export const PAYPAL_CHECKOUT_ORDER = `${PAYPAL_BASE_URL}/v2/checkout/orders`;
export const PAYPAL_BILL_AGREEMENT_TOKEN_URL = `${PAYPAL_BASE_URL}/v1/billing-agreements/agreement-tokens`;
export const PAYPAL_BILL_AGREEMENT = `${PAYPAL_BASE_URL}/v1/billing-agreements/agreements`;
export const PAYPAL_REF_TRANSACTION_PAYMENT_URL = `${PAYPAL_BASE_URL}/v2/checkout/orders`;
export const PAYPAL_DIRECT_ORDER_CAPTURE_URL = (orderId) =>
  `https://api.sandbox.paypal.com/v2/checkout/orders/${orderId}/capture`;

// export const GETPOST = `${API_URL}/api/posts`;
// export const GETDONATE = `${API_URL}/api/donate`;
// export const POSTDONATE = `${API_URL}/api/donate`;
// export const VERIFYEMAIL = `${API_URL}/api/users/verify`;
// export const VERIFYUSER = `${API_URL}/api/users/login`;
// export const UPDATEUSER = `${API_URL}/api/users/17`;
// export const VOLUNTEERS = `${API_URL}/api/volunteering/me`;
// export const CREATECAMPAIGN = `${API_URL}/api/campaigns`;
// export const FETCHNONPROFIT = `${API_URL}/api/nonprofits/search?name=`;
// export const VERIFYTOKEN = `${API_URL}/api/users/verifyToken`;
